import { useQuery } from '@tanstack/react-query';
import { getLastRunRepositoryQuery } from '../apis';

const useGetLastRunRepository = ({ repository }) => {
  const query = useQuery({
    queryKey: ['last-run', repository],
    enabled: !!repository,
    queryFn: () =>
      getLastRunRepositoryQuery({
        repository,
      }),
    staleTime: 0,
  });

  return query;
};

export default useGetLastRunRepository;
